import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full min-h-[50vh] md:min-h-0 md:h-[calc(100vh-13rem)] flex items-center overflow-hidden bg-[#001a3d]" data-id="element-197">
      {/* Background Image */}
      <img src="https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=1920&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" data-id="element-198" />
      <div className="absolute inset-0 bg-[#001a3d]/70" data-id="element-199" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#001a3d]/90 via-[#001a3d]/50 to-transparent" data-id="element-200" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 md:py-16" data-id="element-201">
        <motion.div className="max-w-3xl" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-202">
          <p className="text-sm md:text-base font-semibold tracking-[0.15em] uppercase text-white/80 mb-4" data-id="element-203">
            Welcome to
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 drop-shadow-lg" data-id="element-204">
            Healthy Choice Family Clinic & Urgent Care
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-4" data-id="element-205">
            Landover, MD 20745 & 20785
          </p>
          <p className="text-base md:text-lg text-white/80 mb-10 max-w-2xl leading-relaxed" data-id="element-206">
            Walk-ins welcome. Most insurance accepted. Comprehensive care for
            the whole family — from pediatrics to adult medicine, urgent care,
            and beyond.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-207">
            <a href="#schedule" className="inline-flex items-center justify-center bg-[#E8891D] hover:bg-[#d07a15] text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#001a3d] shadow-lg" data-id="element-208">
              Book Your Appointment
            </a>
            <a href="/dot-physical" className="inline-flex items-center justify-center border-2 border-white/40 hover:bg-white/10 text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-209">
              DOT Physical
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}